/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListToolsetToolSchemaStaticValuesSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListToolsetToolSchemaStaticValuesSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListToolsetToolSchemaStaticValuesSecurity = {
  option1?: ListToolsetToolSchemaStaticValuesSecurityOption1 | undefined;
  option2?: ListToolsetToolSchemaStaticValuesSecurityOption2 | undefined;
};

export type ListToolsetToolSchemaStaticValuesRequest = {
  /**
   * The slug of the toolset
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListToolsetToolSchemaStaticValuesSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListToolsetToolSchemaStaticValuesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListToolsetToolSchemaStaticValuesSecurityOption1$Outbound,
    ListToolsetToolSchemaStaticValuesSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listToolsetToolSchemaStaticValuesSecurityOption1ToJSON(
  listToolsetToolSchemaStaticValuesSecurityOption1:
    ListToolsetToolSchemaStaticValuesSecurityOption1,
): string {
  return JSON.stringify(
    ListToolsetToolSchemaStaticValuesSecurityOption1$outboundSchema.parse(
      listToolsetToolSchemaStaticValuesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListToolsetToolSchemaStaticValuesSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListToolsetToolSchemaStaticValuesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListToolsetToolSchemaStaticValuesSecurityOption2$Outbound,
    ListToolsetToolSchemaStaticValuesSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listToolsetToolSchemaStaticValuesSecurityOption2ToJSON(
  listToolsetToolSchemaStaticValuesSecurityOption2:
    ListToolsetToolSchemaStaticValuesSecurityOption2,
): string {
  return JSON.stringify(
    ListToolsetToolSchemaStaticValuesSecurityOption2$outboundSchema.parse(
      listToolsetToolSchemaStaticValuesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListToolsetToolSchemaStaticValuesSecurity$Outbound = {
  Option1?:
    | ListToolsetToolSchemaStaticValuesSecurityOption1$Outbound
    | undefined;
  Option2?:
    | ListToolsetToolSchemaStaticValuesSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const ListToolsetToolSchemaStaticValuesSecurity$outboundSchema:
  z.ZodMiniType<
    ListToolsetToolSchemaStaticValuesSecurity$Outbound,
    ListToolsetToolSchemaStaticValuesSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        ListToolsetToolSchemaStaticValuesSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        ListToolsetToolSchemaStaticValuesSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function listToolsetToolSchemaStaticValuesSecurityToJSON(
  listToolsetToolSchemaStaticValuesSecurity:
    ListToolsetToolSchemaStaticValuesSecurity,
): string {
  return JSON.stringify(
    ListToolsetToolSchemaStaticValuesSecurity$outboundSchema.parse(
      listToolsetToolSchemaStaticValuesSecurity,
    ),
  );
}

/** @internal */
export type ListToolsetToolSchemaStaticValuesRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListToolsetToolSchemaStaticValuesRequest$outboundSchema:
  z.ZodMiniType<
    ListToolsetToolSchemaStaticValuesRequest$Outbound,
    ListToolsetToolSchemaStaticValuesRequest
  > = z.pipe(
    z.object({
      slug: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function listToolsetToolSchemaStaticValuesRequestToJSON(
  listToolsetToolSchemaStaticValuesRequest:
    ListToolsetToolSchemaStaticValuesRequest,
): string {
  return JSON.stringify(
    ListToolsetToolSchemaStaticValuesRequest$outboundSchema.parse(
      listToolsetToolSchemaStaticValuesRequest,
    ),
  );
}
